import { useRestApiHeaders } from 'business/contextProviders/useApiHeaders';
import { useDefectReportTypeV1ControllerGetList } from 'generated/apiComponents';
import { Module_Enum } from 'generated/graphql';

export const useGetDefectReportTypeData = (constructionSiteId: string) => {
  const restHeaders = useRestApiHeaders(Module_Enum.QualityControl);

  const { data, error, isLoading, refetch } =
    useDefectReportTypeV1ControllerGetList({
      pathParams: {
        constructionSiteId,
      },
      headers: restHeaders,
    });

  return {
    data,
    isLoading,
    error,
    refetch,
  };
};
